<template>
  <div class="demand-market-content-list">
    <TitleCard title="技术需求"
               :loading="loading"
               :isEmpty="isEmpty"
               type='line-name-line'
               @moreClick="toRouter('techDealInfos')"
               :isTabs="isTabs"
               :tabList="tabList"
               @selectTab="selectTab"
               :selectedIndx="selectedIndx">
      <div class="middle-wrap demand-market-body">
        <MarketDemand :tableList="tableList"></MarketDemand>
      </div>
    </TitleCard>
  </div>
</template>
<script>
import { Mixin } from '@/views/TechnicalRLibrary/mixins'
import MarketDemand from '@/components/common/MarketDemand'
const industryList = require('@/utils/industryList')
export default {
  props: {
    isTabs: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      tabList: industryList.industryLists,
      selectedIndx: 0,
      loading: false,
      isEmpty: false,
      selectVal: industryList.industryLists[0],
    }
  },
  mixins: [Mixin],
  components: {
    MarketDemand,
  },

  methods: {
    // tab切换
    selectTab(val) {
      this.selectedIndx = val.index
      this.selectedTab = val.tab.name
      this.params.industrialType = val.tab.key
      this.selectVal = val.tab
      this.init()
    },
    toRouter(router) {
      this.$router.push({
        name: router,
        params: { selectVal: JSON.stringify(this.selectVal) },
      })
    },
  },
}
</script>
